import React, { useState } from 'react';
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, useTheme, Divider, TablePagination, Button, Switch, Grid, Typography, MenuItem, Select, TextField, TableContainer, List, ListItem, ListItemText } from '@mui/material';
import { Box } from '@mui/system';
import InputStylefield from '../../assets/InputStylefield';
import { IconButton } from '@mui/material';
import { Visibility, Edit, Delete } from '@mui/icons-material';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';
import VideocamIcon from '@mui/icons-material/Videocam';
import { enqueueSnackbar } from 'notistack';
import { deleteJobById } from '../../actions/userAuth';
import Layout from '../../assets/Layout';
import UserLayout from '../../assets/UserLayout';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import PhoneIcon from '@mui/icons-material/Phone';

export default function CoachTraining() {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [checked, setChecked] = useState(false);
    const [date, setDate] = useState("");
    const [selectedOption, setSelectedOption] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const theme = useTheme();

    const handleFromDateChange = (event) => {
        setFromDate(event.target.value);
    };

    const handleToDateChange = (event) => {
        setToDate(event.target.value);
    };

    const handleChange1 = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleChange = () => {
        setChecked(!checked);
    };

    const navigate = useNavigate();


    const data = [
        { id: 1, header1: 'Ackrolix Innovation', header2: 'Data 2', header3: 'Data 3', header4: '24- April 2023', header5: 'Data 5', header6: 'Deactivate', header7: 'Data 7' },
        { id: 2, header1: 'Data 1', header2: 'UI UX Designer', header3: 'Data 3', header4: 'Data 4', header5: 'Active', header6: 'Activate', header7: 'Data 7' },
        { id: 3, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Active', header6: 'Rejected', header7: 'Data 7' },
        { id: 4, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Deactivate', header6: 'Under Review', header7: 'Data 7' },
        { id: 5, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Closing Soon', header6: 'Draft', header7: 'Data 7' },
        { id: 6, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Deleted', header6: 'Data 6', header7: 'Data 7' },
        { id: 7, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Active', header6: 'Data 6', header7: 'Data 7' },
        // Add more data objects as needed
    ];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearch = (event) => {
        const searchTerm = event.target.value;
    };

    const handleDeleteJob = () => {
        // var temp = [...jobs];
        // console.log(temp[index]._id);
        // dispatch(deleteJobById(temp[index]._id, {}, (data) => {
        //     temp.splice(index, 1);
        //     setJobs(temp);
        //     enqueueSnackbar("Job deleted successfully", { variant: 'success' });
        // }, (err) => {
        //     enqueueSnackbar("Error Occrred! Please try again", { variant: 'error' });
        // }))
    }




    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    return (
        <Layout>
            <UserLayout userRole={"coach"}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        my: 8,
                    }}
                >
                    <Button
                        className="text2Mid"
                        sx={{
                            py: 0.5,
                            px: 2,
                            backgroundColor: '#F7FAFF',
                            borderRadius: '0.5rem',
                            color: '#2544EE',
                            border: '1px solid #2544EE',
                            '&:hover': {
                                color: '#fff',
                                backgroundColor: '#2544EE',
                            },
                            ...(theme.breakpoints.down('md') && {
                                my: 2, // Apply vertical margin for mobile view
                            }),
                        }}
                        startIcon={<ArrowBackIosIcon />}
                        onClick={() => navigate('/candidate/dashboard')}
                        variant="contained"
                    >
                        Go Back
                    </Button>
                    <TextField
                        variant="outlined"
                        size="small"
                        placeholder="Search"
                        onChange={handleSearch}
                        InputProps={{
                            endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                        }}
                    />
                </Box>


                <Paper sx={{ px: 5, py: 2, boxShadow: 'none', border: '1px solid #e0e0e0', backgroundColor: '#F8FAFF' }} >
                    <Typography className='heading2bold' sx={{ fontWeight: 'bold', width: '100%' }}>Training Name</Typography>
                    <Box sx={{ my: 2 }}>
                        <Typography className='subHeading2Mid'>Service Detail by Coach</Typography>
                        <ul>
                            <li className='text1Mid' style={{ marginTop: '16px' }}>
                                Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Massa mattis molestie amet dui volutpat. Tellus lacinia pulvinar pharetra viverra morbi tincidunt mi mus.
                            </li >
                            <li className='text1Mid' style={{ marginTop: '16px' }}>
                                Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Massa mattis molestie amet dui volutpat. Tellus lacinia pulvinar pharetra viverra morbi tincidunt mi mus.
                            </li>
                            <li className='text1Mid' style={{ marginTop: '16px' }}>
                                Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Massa mattis molestie amet dui volutpat. Tellus lacinia pulvinar pharetra viverra morbi tincidunt mi mus.
                            </li>
                        </ul>
                    </Box>

                    <Typography className='subHeading2Bold' sx={{ fontWeight: 'bold', width: '100%', mt: 5 }}>Medium</Typography>
                    <Box sx={{ px: 3, backgroundColor: '#2544EE', width: 'fit-content', py: 1, borderRadius: '32px' }}>
                        <PhoneIcon sx={{ color: '#fff', }} />
                    </Box>


                    <Typography className="text2Bold" sx={{ fontWeight: 'bold', width: 'max-content', mt: 4, }}>
                        Entered Price:
                    </Typography>
                    <Box sx={{ mt: 2, display: 'flex', flexDirection:{md:'row', xs:'column'}, gap:{md:0, xs:2} }}>

                        <Box style={{ display: 'block' }}>
                            <Typography className="text2Mid trainingScreenInfo" component="span">
                                <p style={{ color: '#2544EE', margin: 0 }}>
                                    <b style={{ color: '#000' }}>₹600</b> : Suggested Price: ₹630
                                </p>
                            </Typography>
                        </Box>

                        <Box style={{ display: 'block' }}>
                            <Typography className="text2Mid trainingScreenInfo" component="span">
                                <p style={{ color: '#2544EE', margin: 0 }}>
                                    <b style={{ color: '#000' }}>Language</b> : English
                                </p>
                            </Typography>
                        </Box>

                        <Box style={{ display: 'block' }}>
                            <Typography className="text2Mid trainingScreenInfo" component="span">
                                <p style={{ color: '#2544EE', margin: 0 }}>
                                    <b style={{ color: '#000' }}>Number of Session</b> : 3
                                </p>
                            </Typography>
                        </Box>
                        <Box style={{ display: 'block' }}>
                            <Typography className="text2Mid trainingScreenInfo" component="span">
                                <p style={{ color: '#2544EE', margin: 0 }}>
                                    <b style={{ color: '#000' }}>Service Duration</b> : 180 min
                                </p>
                            </Typography>


                        </Box>
                        <Box style={{ display: 'block' }}>
                            <Typography className="text2Mid trainingScreenInfo" component="span">
                                <p style={{ color: '#2544EE', margin: 0 }}>
                                    <b style={{ color: '#000' }}>Duration/Session</b> : 60min
                                </p>
                            </Typography>
                        </Box>
                    </Box>

                    <Grid container mt={6}>
                        <Grid item md={6}>
                            <Grid container>
                                <Grid item md={6}>

                                    <Typography className="subHeading2Bold" sx={{ fontWeight: 'bold', width: 'max-content', }}>
                                        Service Started on :
                                    </Typography>
                                </Grid>
                                <Grid item md={6}>
                                    <Typography className="text2Mid trainingScreenInfo" component="span">
                                        12 April 2023
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item md={6}>
                            <Grid container>
                                <Grid item md={6}>

                                    <Typography className="subHeading2Bold" sx={{ fontWeight: 'bold', width: 'max-content', }}>
                                        Last Edited on:
                                    </Typography>
                                </Grid>
                                <Grid item md={6}>
                                    <Typography className="text2Mid trainingScreenInfo" component="span">
                                        12 April 2023
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>


                </Paper>
            </UserLayout>
        </Layout>

    );
}
